import { render, staticRenderFns } from "./TeachResourceDetails.vue?vue&type=template&id=168410be&scoped=true"
import script from "./TeachResourceDetails.vue?vue&type=script&lang=js"
export * from "./TeachResourceDetails.vue?vue&type=script&lang=js"
import style0 from "./TeachResourceDetails.vue?vue&type=style&index=0&id=168410be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168410be",
  null
  
)

export default component.exports